var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenCheckmarkVolume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1543_53238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5229 20 20 15.5229 20 10C20 4.47716 15.5229 0 10 0C4.47716 0 0 4.47716 0 10C0 15.5229 4.47716 20 10 20Z",
    fill: "#1AC057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9.99997C20 15.5 15.5 20 10 20C6.81253 20 4.00002 18.5625 2.1875 16.25C3.875 17.625 6.06251 18.4375 8.43749 18.4375C13.9375 18.4375 18.4375 13.9375 18.4375 8.43749C18.4375 6.06251 17.625 3.875 16.25 2.1875C18.5625 3.99994 20 6.81244 20 9.99997Z",
    fill: "#13A94A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.438 7.12496L8.93796 14.25C8.50044 14.75 7.75047 14.75 7.31295 14.25L4.56294 11.1875C4.18796 10.75 4.18796 10.0625 4.62543 9.62497C5.06295 9.24998 5.75043 9.24998 6.18795 9.68746L8.12546 11.875L13.8129 5.68747C14.2505 5.24995 14.938 5.18746 15.3755 5.62498C15.8129 5.99996 15.8129 6.74998 15.438 7.12496Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1543_53238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckmarkVolume);
export default __webpack_public_path__ + "static/media/green-checkmark-volume.acf87ce167ed90465411217d27b5cd25.svg";
export { ForwardRef as ReactComponent };